export enum UpdatesListColumns {
  'ID' = 'ID',
  'TITLE' = 'Title',
  'INCLUDED_SEGMENTS' = 'Included Segments',
  'TRANSLATIONS' = 'Translations',
  'STATUS' = 'Status',
  'LAUNCH_DATE' = 'Launch Date'
}
export const UPDATES_STATUSES = {
  DRAFT: 'Draft',
  LIVE: 'Live',
  HIDDEN: 'Hidden',
  EXPIRED: 'Expired'
}
export const updatesStatusMap = {
  [UPDATES_STATUSES.LIVE.toUpperCase()]: {
    borderColor: 'border-green-500',
    bgColor: 'bg-lighter-green',
    color: 'green'
  },
  [UPDATES_STATUSES.HIDDEN.toUpperCase()]: {
    borderColor: 'border-gray-500',
    bgColor: 'bg-lighter-gray',
    color: 'gray'
  },
  [UPDATES_STATUSES.EXPIRED.toUpperCase()]: {
    borderColor: 'border-red-500',
    bgColor: 'bg-lighter-red',
    color: 'red'
  },
  [UPDATES_STATUSES.DRAFT.toUpperCase()]: {
    borderColor: 'border-blue-500',
    bgColor: 'bg-lighter-blue',
    color: 'blue'
  }
}
export const UPDATES_FILTERS_KEYS = {
  STATUSES: 'selectedStatuses',
  SEARCH: 'search'
}

export const UPDATES_DETAILS_MORE_MENU_ITEMS = ['Update Status', 'Duplicate']
export const DRAFT_UPDATES_DETAILS_MORE_MENU_ITEMS = ['Delete', 'Duplicate']
export const UPDATES_STATUS = 'Update Status'
export const DELETE = 'Delete'
export const UPDATES_DETAILS_TABS = ['Settings', 'Segments', 'Translations']
export const UPDATES_DETAILS_TITLES = {
  UPDATE_CARD_LAYOUT: 'Update Card Layout',
  UPDATE_CARD_BADGES: 'Badges'
}
export const INCREMENT_COUNTER = 1
export const UPDATE_STATUS = 'Update Status'

export const UPDATE_CARD_STATUS = [
  { label: 'Live', value: false },
  { label: 'Hidden', value: true }
]
export const UPDATE_CARD_STATUSES = {
  LIVE: 'LIVE',
  HIDDEN: 'HIDDEN',
  EXPIRED: 'EXPIRED',
  DRAFT: 'DRAFT'
}

export const UPDATES_SEGMENTS_TAB_TEXT = {
  INCLUDED: {
    TITLE: 'Segments that can see the Update Card',
    DESCRIPTION:
      'Only the users that are included in at least one of this segments, are going to be able to see the Update Card.'
  },
  EXCLUDED: {
    TITLE: 'Segments that are excluded from the Update Card',
    DESCRIPTION:
      'If a user is Included on any of this segments, he is not going to be able to see this Update Card.'
  }
}

export const UPDATES = 'Update Card'

export const ROW_STYLE = 'flex flex-row justify-between p-3 mt-5'
export const COL_STYLE = 'flex flex-col w-3/5 space-y-3'

export const CREATE_OR_EDIT_UPDATE_CARD_TABS = ['Information', 'Settings']
export const CREATE_OR_EDIT_UPDATE_CARD_TABS_INDEX = {
  INFORMATION: 0,
  SETTINGS: 1
} as const
export const CREATE_OR_EDIT_UPDATE_CARD_TITLES = {
  CARD_INFO: 'Card Information',
  CARD_DETAIL: 'Card Detail',
  UPDATE_CARD_LAYOUT: 'Update Card Layout',
  UPDATE_CARD_DATES: 'Update Card Dates',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  NAME: 'Name',
  TITLE: 'Title',
  SUBHEADER1: 'Sub-header1',
  SUBHEADER2: 'Sub-header2',
  DESCRIPTION: 'Description',
  UPDATE_CARD_IMAGE: 'Image (optional)',
  UPDATE_CARD_ICON: 'Icon (optional)',
  UI_POSITION: 'Update Card UI Position',
  BUTTON: 'Button',
  NO_TITLE: '',
  LABEL: 'Label',
  LINK: 'Link',
  SEGMENTS: 'Segments',
  AVAILABLE_SEGMENTS: 'Segments that will be able to see the Update Card',
  EXCLUDED_SEGMENTS:
    'Segments that will be excluded from seeing the Update Card'
}
export const CREATE_OR_EDIT_UPDATE_CARD_SUB_TITLES = {
  CARD_INFO: 'This information will be displayed on the Update Card List.',
  CARD_DETAIL:
    'Displayed when the user presses on the Update Card to open the detail view.',
  UPDATE_CARD_LAYOUT:
    'Defines the position of the Update Card inside the Earn section of Rewards.',
  POINTS_VALUE:
    'The Listed Points, are the points required to redeem the Update Card, and the Real Points defines the real value in points of this Update Card.',
  UI_POSITION: 'Press on the Reorder option to set a new position',
  UPDATE_CARD_DATES:
    'The day and time selections on this fields are based on UTC Time.',
  SEGMENTS_INCLUDED:
    'Select the list of specific segment that will be able to see this Update Card. It can also be set to be available to All Users.',
  SEGMENTS_EXCLUDED:
    'For the excluded segments, any user that is part of this segments wont be able to see or redeem on this Update Card.'
}
export const CREATE_OR_EDIT_UPDATE_CARD_KEYS = {
  NAME: 'Name',
  TITLE: 'Title',
  SUBHEADER1: 'SubHeader1',
  SUBHEADER2: 'SubHeader2',
  UPDATE_CARD_IMAGE: 'ImageID',
  UPDATE_CARD_ICON: 'Icon',
  DESCRIPTION: 'Description',
  CTA_LABEL: 'CtaLabel',
  CTA_LINK: 'CtaLink',
  CATEGORY: 'Category',
  UI_POSITION: 'UiPosition',
  UPDATE_CARD_ID: 'toCreate',
  START_TIME: 'StartDateUTC',
  END_TIME: 'EndDateUTC',
  AVAILABLE_SEGMENTS: 'availableSegments',
  EXCLUDED_SEGMENTS: 'excludeSegments'
}
export const UPDATE_CARD = 'Update Card'

export const CREATE_OR_EDIT_UPDATE_CARD_IMG_TYPES = {
  IMAGE: 'image',
  ICON: 'icon'
} as const

export const SEGMENTS_TYPES = {
  AVAILABLE_SEGMENTS: 'availableSegments',
  EXCLUDED_SEGMENTS: 'excludeSegments'
}
export const UPDATE_CARD_TRANSLATIONS_COLUMN_NAME: UpdateCardTranslationsFields =
  {
    Title: 'Title',
    SubHeader1: 'Sub-header 1',
    SubHeader2: 'Sub-header 2',
    Description: 'Description',
    CtaLabel: 'CTA Label'
  }
export const UPDATE_CARD_TABS_INDEX = {
  SETTINGS: 0,
  SEGMENTS: 1,
  TRANSLATIONS: 2
}

export const UPDATE_CARD_TRANSLATIONS_KEYS = [
  'Title',
  'SubHeader1',
  'SubHeader2',
  'Description',
  'CtaLabel'
]

export const DRAFT_UPDATE = 'Draft Update Card'

export const TRACK_UPDATES_EVENTS = {
  CREATE: 'Create New Updates',
  DRAFT: 'Save as a Draft'
}
